import React, { Component, lazy, Suspense } from 'react';
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import Auth from "../../../Layout/Auth";
import AboutUs from "../Pages/AboutUs";
import TermsConditions from "../Pages/TermsConditions";
import Faq from "../Pages/Faq";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import Sitemap from "../Pages/Sitemap";
function FooterListRoute() {
    const history = useHistory();
    return (

        <Switch>
            <Route
                exact
                path="/:lng/about-us"
                render={() => (
                    <Auth history={history}>
                        <Suspense>
                            <AboutUs/>
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/terms-conditions"
                render={() => (
                    <Auth history={history}>
                        <Suspense>
                            <TermsConditions/>
                        </Suspense>

                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/faq"
                render={() => (
                    <Auth history={history}>
                        <Suspense>
                            <Faq/>
                        </Suspense>

                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/privacy-policy"
                render={() => (
                    <Auth history={history}>
                        <Suspense>
                            <PrivacyPolicy/>
                        </Suspense>

                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/sitemap"
                render={() => (
                    <Auth history={history}>
                        <Suspense>
                            <Sitemap/>
                        </Suspense>

                    </Auth>
                )}
            />

        </Switch>
    );
}


export default FooterListRoute;
